import { render } from "./FlatFeats.vue?vue&type=template&id=3e8379a8&scoped=true"
import script from "./FlatFeats.vue?vue&type=script&lang=js"
export * from "./FlatFeats.vue?vue&type=script&lang=js"

import "./FlatFeats.vue?vue&type=style&index=0&id=3e8379a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8379a8"]])

export default __exports__